
import {
  VisualQualityControlDto,
  CreateVisualQualityControlDto,
  UpdateVisualQualityControlDto,
  VisualQualityControlType,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type VisualQualityControlsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  type?: VisualQualityControlType
  search?: string
}

class VisualQualityControlService extends BaseCrudService<
  VisualQualityControlDto,
  CreateVisualQualityControlDto,
  UpdateVisualQualityControlDto,
  VisualQualityControlsFilters
> {
  constructor() {
    super('visual-quality-control', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const visualQualityControlService = new VisualQualityControlService()
